import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-help-center-dialog',
    templateUrl: './help-center-dialog.component.html',
    styleUrls: ['./help-center-dialog.component.scss'],
    standalone: false
})
export class HelpCenterDialogComponent implements OnInit {

  constructor(private matdialogRef: MatDialogRef<HelpCenterDialogComponent>, private sidenaveService: SidenavService) { }

  ngOnInit(): void {
  }

  openContactUs(): void {
    this.matdialogRef.close();
    // this.sidenaveService.openInRightSidenav(ContactUsDialogComponent);
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }

}
